import { Badge, Box, Typography } from "@mui/material";
import { ModeComment } from "@mui/icons-material";
import { format, isToday, isYesterday } from "date-fns";
import { Avatar } from "../Avatar";

type CommentUser = {
	id: string;
	avatar?: string;
	first_name: string;
	last_name: string;
};

type Comment = {
	id: string;
	date_created: string;
	date_updated: string | null;
	user_created: CommentUser;
};

type CommentsProps = {
	value: {
		row: {
			comments: Array<Comment>;
		};
	};
};

const formatCommentDate = (dateString: string) => {
	const date = new Date(dateString);

	if (isToday(date)) {
		return "Hoje";
	}

	if (isYesterday(date)) {
		return "Ontem";
	}

	const formattedDate = format(date, "dd/MM/yy");
	return formattedDate;
};

export const Comments = ({ value }: CommentsProps) => {
	const comments = value.row?.comments;
	const totalComments = comments?.length || 0;

	if (totalComments === 0) {
		return null;
	}

	const latestComment = comments.reduce((latest, comment) => {
		const latestDate = new Date(latest.date_created);
		const currentDate = new Date(comment.date_created);
		const isCurrentNewer = currentDate > latestDate;
		return isCurrentNewer ? comment : latest;
	});

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
			<Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", lineHeight: 1.2 }}>
				<Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
					{formatCommentDate(latestComment.date_created)}
				</Typography>
				<Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
					{format(new Date(latestComment.date_created), "HH:mm")}
				</Typography>
			</Box>
			<Avatar value={latestComment.user_created?.avatar} styles={{ width: 28, height: 28 }} />
			<Badge badgeContent={totalComments} color="secondary">
				<ModeComment color="action" />
			</Badge>
		</Box>
	);
};
